import { motion, AnimatePresence } from 'framer-motion'
import { X as XIcon, Settings } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

interface Props {
  isOpen: boolean
  onClose: () => void
  userName?: string
  userEmail?: string
}

export default function MobileMenuDrawer({ isOpen, onClose, userName, userEmail }: Props) {
  const navigate = useNavigate()

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 z-65 bg-black/30 backdrop-blur-sm sm:hidden"
            onClick={onClose}
          />
          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ duration: 0.28, ease: [0.16, 1, 0.3, 1] }}
            className="fixed top-0 right-0 bottom-0 z-70 w-[300px] bg-white
                       shadow-[−8px_0_32px_rgba(44,24,16,0.12)] sm:hidden"
            dir="rtl"
          >
            <div className="flex items-center justify-between px-5 py-4 border-b border-[#F2EDE4]">
              {/* <span className="flex flex-row-reverse font-serif text-lg font-bold text-[#1A1A1A]">
                <span className="text-[#F4845F] text-2xl">i</span>
                <span className="text-[#2D6A4F]">Market</span>
              </span> */}
              {/* Logo */}
            <div className="flex items-center gap-2">
              {/* Mobile */}
              <span className="sm:hidden font-serif text-[1.25rem] font-bold tracking-tight leading-none">
                <span className="text-[#F4845F]">i</span>
                <span className="text-[#2D6A4F]">Market</span>
              </span>
              {/* Desktop */}
              <span className="hidden sm:inline font-serif text-2xl font-bold tracking-tight leading-none">
                <span className="text-[#F4845F]">i</span>
                <span className="text-[#2D6A4F]">Market</span>
              </span>
              
            </div>
              <button
                onClick={onClose}
                className="w-8 h-8 flex items-center justify-center rounded-lg
                           hover:bg-[#F2EDE4] transition-colors border-none cursor-pointer bg-transparent"
              >
                <XIcon className="w-6 h-6 lg:w-4 lg:h-4 text-[#6B6560]" />
              </button>
            </div>

            <nav className="px-3 py-4 flex flex-col gap-1" aria-label="תפריט מובייל">
              <button
                onClick={() => { navigate('/admin'); onClose() }}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-[1rem] lg:text-1xl font-medium
                           text-[#1A1A1A] hover:bg-[#F2EDE4] transition-colors
                           border-none bg-transparent cursor-pointer w-full text-right"
              >
                <Settings className="w-4.5 h-4.5 text-[#6B6560]" />
                ניהול
              </button>
            </nav>

            <div className="absolute bottom-8 px-5 w-full">
              <p className="text-[11px] text-[#6E6660]">מחובר כ-{userName}</p>
              <p className="text-[12px] font-medium text-[#6B6560] truncate">{userEmail}</p>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}